export enum BenchmarkType {
  NONE = 'none',
  VS_EXTERNAL_BENCHMARK = 'vs_external_benchmark',
  VS_COMPANY_AVERAGE = 'vs_company_average',
}
